

import React from "react";

import "./page__index.css";

import { Plan, ProductsFetch } from "@/api/products";
import { useProductStore } from "@/store/product";
import { useActiveStore } from "@/store/activePages";

import Columns from "@/components/Columns";
import Column from "@/components/Column";
import Glider from "@/components/Glider";
import ProductCard from "@/components/ProductCard";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";

// Invalid Page Layout
const InvalidPageLayout = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="px-2 pt-10">
      <SEO
        title="Escolha o seu novo plano TIM"
        description="Adicione o plano TIM para continuar o processo de compra."
      />
      <Columns justifyContent="center" className="pb-10 pt-4">
        <Column size={12} className="text-center">
          <PageHeader
            title={
              <div className="pt-8">
                <p>
                  O plano escolhido não está disponível no momento, por favor
                  escolha outro.
                </p>
                <p className="text-lg">
                  Não se preocupe, você continuará o processo de onde parou após
                  escolher um novo plano!
                </p>
              </div>
            }
            dataIcTitle="sec-omega-comunicacao"
          />
        </Column>

        {children}
      </Columns>
    </div>
  );
};

// Invalid Page
export const InvalidPage = () => {
  const { data: products } = ProductsFetch();

  const addPage = useActiveStore((store) => store.addPage);
  const setProduct = useProductStore((store) => store.setProduct);

  const handleProductSelect = (product: Plan) => {
    setProduct(product);
    addPage("/payment-data");
  };

  return (
    <InvalidPageLayout>
      <div className="glider--initial-page glider-contain mt-2 pt-12">
        <Glider>
          {products?.map((product) => (
            <div key={product.nome} className="px-2">
              <ProductCard
                to="/payment-data"
                product={product}
                onSelect={handleProductSelect}
              />
            </div>
          ))}
        </Glider>
      </div>
    </InvalidPageLayout>
  );
};

export default InvalidPage;
